<template>
  <b-row>
    <b-col cols="12" md="12" xl="12">
      <b-card
        :style="{ backgroundColor: coloreSfondo, color: coloreTesto, borderColor: coloreBordo }"
      >
        <button
          v-show="false"
          v-tooltip="{
            content: uniToolTipTranslation('TRNSL246', 'en-US'),
            placement: 'top'
          }"
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni,
            width: '25%'
          }"
          type="button"
          class="btn btn-default"
          @click="setBAdvanced"
        >
          <i class="fa-solid fa-pen-ruler"></i>
          {{ uniTranslation("TRNSL246") }}
        </button>
        <b-card-body v-show="false">
          <div>
            <!-- == MODIFICHE DA LASCIARE DIVERSE == -->
            <div style="padding-bottom: 30px" class="row">
              <div v-show="false" class="col-2">
                <el-checkbox v-model="fixedCircuits" /> {{ uniTranslation("TRNSL185") }}
              </div>
              <div class="col-2">
                <el-checkbox v-model="connessioni" /> {{ uniTranslation("TRNSL186") }}
              </div>
              <div class="col-8"></div>
            </div>
            <div class="row">
              <div class="col-2">
                <el-checkbox v-model="filtraPerPerditeCarico" /> {{ uniTranslation("TRNSL183") }}
              </div>
              <div class="col-5">
                <label v-tooltip="uniToolTipTranslation('TRNSL214', 'en-US')"
                v-show="filtraPerPerditeCarico"
                  >{{ uniTranslation("TRNSL214") }} - {{ tolleranzaPdcPrim }}</label
                >
                <el-slider
                  v-show="filtraPerPerditeCarico"
                  v-model="tolleranzaPdcPrim"
                  :step="sliderStep"
                  :disabled="!filtraPerPerditeCarico"
                />
              </div>
              <div class="col-5">
                <label v-tooltip="uniToolTipTranslation('TRNSL215', 'en-US')"
                v-show="filtraPerPerditeCarico"
                  >{{ uniTranslation("TRNSL215") }} - {{ tolleranzaPdcSecon }}</label
                >
                <el-slider
                  v-show="filtraPerPerditeCarico"
                  v-model="tolleranzaPdcSecon"
                  :step="sliderStep"
                  :disabled="!filtraPerPerditeCarico"
                />
              </div>
              
              <div style="margin-bottom: 59px" class="row" v-show="filtraPerPerditeCarico == false"></div>
              <div class="col-2">
                <el-checkbox v-model="filtraPerPotenza" /> {{ uniTranslation("TRNSL184") }}
              </div>
              <div class="col-5" style="width: 100%">
                <label v-tooltip="uniToolTipTranslation('TRNSL39', 'en-US')"
                  v-show="filtraPerPotenza"
                  >{{ uniTranslation("TRNSL39") }} - {{ tollNeg }}</label
                >
                <el-slider
                  v-model="tollNeg"
                  v-show="filtraPerPotenza"
                  :step="sliderStep"
                  :disabled="!filtraPerPotenza"
                />
              </div>
              <div class="col-5" style="width: 100%">
                <label v-tooltip="uniToolTipTranslation('TRNSL187', 'en-US')"
                  v-show="filtraPerPotenza"
                  >{{ uniTranslation("TRNSL187") }} - {{ tollPos }}</label
                >
                <el-slider
                  v-model="tollPos"
                  v-show="filtraPerPotenza"
                  :step="sliderStep"
                  :disabled="!filtraPerPotenza"
                />
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { Slider, Checkbox } from "element-ui";
import { mapActions, mapGetters } from "vuex";
import jsonHelper from "../../shared/jsonHelper";

export default {
  components: {
    "el-slider": Slider,
    "el-checkbox": Checkbox
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      path: null,
      calculationType: "",
      coloreSfondo: "",
      coloreTesto: "",
      coloreBordo: "",
      fixedCircuits: Boolean,
      connessioni: Boolean,
      filtraPerPotenza: false,
      tollPos: 0,
      tollNeg: 0,
      tolleranzaPdcPrim: 0,
      tolleranzaPdcSecon: 0,
      filtraPerPerditeCarico: true,
      sliderStep: 5,
      coloreFooterBottoni: "",
      coloreTestoBottoni: "",
      coloreBordoBottoni: "",
      bAdvanced: false
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects", "isSaldobrasata", "defValues"]),
    ...mapGetters("_commonModule", ["isInManagement"]),
    ...mapGetters("_colorsModule", ["cardColors", "footerColors"])
  },
  watch: {
    cardColors() {
      this.setColors();
    },
    footerColors() {
      this.setColors();
    },
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    },
    tollPos: function(newval /*, oldval*/) {
      this.changeProperty({
        path: this.path + ".capacityTolerancePositive",
        value: newval
      });
    },
    tollNeg: function(newval /*, oldval*/) {
      this.changeProperty({
        path: this.path + ".capacityToleranceNegative",
        value: newval
      });
    },
    connessioni: function(newval /*, oldval*/) {
      this.changeProperty({
        path: this.path + ".connections",
        value: newval
      });
    },
    fixedCircuits: function(newval /*, oldval*/) {
      this.changeProperty({
        path: this.path + ".fixedCircuits",
        value: newval
      });
    },
    tolleranzaPdcPrim: function(newval /*, oldval*/) {
      this.changeProperty({
        path: this.path + ".pressureDropTolerancePrimario",
        value: newval
      });
    },
    tolleranzaPdcSecon: function(newval /*, oldval*/) {
      this.changeProperty({
        path: this.path + ".pressureDropToleranceSecondario",
        value: newval
      });
    },
    filtraPerPotenza: function(newval /*, oldval*/) {
      //console.log(newval);
      this.changeProperty({
        path: this.path + ".capacityFilter",
        value: newval
      });
    },
    filtraPerPerditeCarico: function(newval /*, oldval*/) {
      this.changeProperty({
        path: this.path + ".pressureDropFilter",
        value: newval
      });
    }
  },
  created: function() {
    if (this.parentPath && this.localPath) this.path = this.parentPath + this.localPath;
  },
  mounted: function() {
    var that = this;
    that.setColors();
    that.loadValues();
  },
  methods: {
    ...mapActions("_prjModule", ["changeProperty"]),
    loadValues() {
      this.tollPos = jsonHelper.getProperty(
        this.projects,
        this.path + ".capacityTolerancePositive"
      );
      this.tollNeg = jsonHelper.getProperty(
        this.projects,
        this.path + ".capacityToleranceNegative"
      );
      this.connessioni = jsonHelper.getProperty(this.projects, this.path + ".connections");
      this.fixedCircuits = jsonHelper.getProperty(this.projects, this.path + ".fixedCircuits");
      this.latoPrimarioSlider = jsonHelper.getProperty(
        this.projects,
        this.path + ".pressureDropTolerancePrimario"
      );

      this.tolleranzaPdcSecon = jsonHelper.getProperty(
        this.projects,
        this.path + ".pressureDropToleranceSecondario"
      );
      this.tolleranzaPdcPrim = jsonHelper.getProperty(
        this.projects,
        this.path + ".pressureDropTolerancePrimario"
      );

      this.filtraPerPotenza = jsonHelper.getProperty(this.projects, this.path + ".capacityFilter");

      this.filtraPerPerditeCarico = jsonHelper.getProperty(
        this.projects,
        this.path + ".pressureDropFilter"
      );
    },
    setBAdvanced() {
      this.bAdvanced = !this.bAdvanced;

      /*if (this.bAdvanced == false) {
        var datiDef = this.isSaldobrasata
          ? this.defValues.brz.bottomSelection
          : this.defValues.isp.bottomSelection;

        this.changeProperty({
          path: this.path,
          value: JSON.parse(JSON.stringify(datiDef))
        });
        this.loadValues();
      }*/
    },
    setColors() {
      var that = this;

      that.coloreSfondo = that.cardColors[0] + " !important";
      that.coloreTesto = that.cardColors[2];
      that.coloreBordo = that.cardColors[6];

      that.coloreFooterBottoni = that.footerColors[2] + " !important";
      that.coloreTestoBottoni = that.footerColors[3];
      that.coloreBordoBottoni = that.footerColors[4];
    }
  }
};
</script>

<style lang="scss">
.no-border-bottom {
  div {
    .el-collapse-item__header {
      border-bottom: none;
    }
  }
}
</style>
